import React from "react";
import { SECTIONS } from "components/FormerEditor/utils";
import HoverIconButton from "components/HoverIconButton";
import { COLORS } from "utils/styles";
import { ACTIVE_HOVER_BUTTON_CLASSES } from "utils/constants/ui";
import Link from "next/link";
import { useManifestSection } from "utils/hooks/manifest";
import { useIsManfestPath } from "utils/hooks/manifest";

const DEFAULT_CLASSES = {
  container: "flex flex-column ph3 pt3-ns mw-app center w-100",
  header: "f3 fw6",
  subheader: "f5 f4-ns pt3 lh-copy",
  copy: "f6 f5-ns pt2 lh-copy",
  actionsWrapper: "flex flex-row items-center pv3",
  action: "f5 link color-primary fw5 link__decoration--hover pl2 pointer"
};

const SectionHeader = ({ header, subheader, copy, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const destination = useManifestSection(SECTIONS.PAGE_BUILDER);
  const isManifestPath = useIsManfestPath();

  return (
    <div className={classes.container}>
      {header && <div className={classes.header}>{header}</div>}
      {subheader && <div className={classes.subheader}>{subheader}</div>}
      {copy && <div className={classes.copy}>{copy}</div>}
      {isManifestPath && (
        <Link href={destination}>
          <div className={classes.actionsWrapper}>
            <HoverIconButton
              type="back"
              tooltip="Back"
              color={COLORS.white}
              customClasses={ACTIVE_HOVER_BUTTON_CLASSES}
            />
            <div className={classes.action}>Back to builder</div>
          </div>
        </Link>
      )}
    </div>
  );
};

export default SectionHeader;
